import React, { useState } from 'react';
import NamedBox from '../atoms/NamedBox';
import CloseButton from '../atoms/CloseButton';
import ListItem from '../atoms/ListItem';
import ClassIcon from '../icons/ClassIcon';
import SchoolIcon from '../icons/SchoolIcon';
import OffersIcon from '../icons/OffersIcon';
import TFPillLogoColorIcon from '../icons/TFPillLogoColorIcon';
import RugbyIcon from '../icons/RugbyIcon';
import StateIllinoisIcon from '../icons/StateIllinoisIcon';
import PositionRankIcon from '../icons/PositionRankIcon';
import Links from '../molecules/Links';
import { COLOR_BLUE, COLOR_MIDDLE_GRAY, COLOR_TEXT, COLOR_WHITE } from '../styles/colors';
import {
    Box,
    Chip,
    makeStyles,
    Typography,
  } from '@material-ui/core';
import ProgressLine from '../atoms/ProgressLine';
import HandshakeIcon from '../icons/HandshakeIcon';
import StarIcon from '../icons/StarIcon';
import Stars from '../atoms/Stars';
import NotAvailable from '../atoms/NotAvailable';
import TeamLogo from '../atoms/TeamLogo';
import { formatDateToLongMonth } from '../services/converter';
import TeamsIcon from '../icons/TeamsIcon';
import { prepareLinks } from '../services/player';
import Tooltip from '../atoms/Tooltip';

const useStyles = makeStyles(theme => ({
    listItem: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1.2,
  
      '& a': {
        color: COLOR_BLUE
      },

      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.pxToRem(14),
      },
    },
    listHiddenIcon: {
      visibility: 'hidden',
    },
    dividedContent: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: theme.spacing(.5, 1.5),

      '@media (max-width: 1680px)': {
        gap: theme.spacing(.5, 1),
      },
    },
    dividedContentSection: {
      display: 'flex',
      alignItems: 'center',
      paddingRight: theme.spacing(1.5),
      borderRight: `1px solid ${COLOR_MIDDLE_GRAY}`,
      lineHeight: 1.1,
  
      '&:last-child': {
        paddingRight: 0,
        borderRight: 0,
      },

      '@media (max-width: 1680px)': {
        paddingRight: theme.spacing(1),
      },
    },
    progressLine: {
      maxWidth: 350,
      padding: 0,
    },
    recruitingLinks: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 100,
      padding: theme.spacing(4),

      '& ul': {
        gap: theme.spacing(4),
        justifyContent: 'center',
      },

      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(1),
      },
    },
    recruitingLink: {
      margin: 0,

      '& img': {
        maxHeight: 20,
      },
    },
    committedTeam: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2),
    },
    committedTeamLogo: {
      width: 'auto',
      height: '32px',
    },
    headerIcon: {
      width: '24px',
      height: '24px',
      color: COLOR_TEXT,
      marginRight: theme.spacing(1),
    },
    rankingWrap: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      maxWidth: '230px',
      gap: theme.spacing(2),
      padding: theme.spacing(2, 0),
    },
    rankingContent: {
      display: 'flex',
      flexDirection: 'column',
      marginRight: 'auto',
      fontWeight: 700,
    },
    rankingIcon: {
      maxWidth: '28px',

      '& img': {
        display: 'block',
        maxWidth: '100%',
      }
    },
    closeButton: {
      marginLeft: 'auto',
    },
    starRatingRow: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'nowrap',
      gap: theme.spacing(.5, 2),
    },
    chip: {
      borderWidth: '2px',
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 700,
      height: 26,
      color: COLOR_WHITE,
    },
    offersRow: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: theme.spacing(2),
    },
    offerLogo: {
      height: 32,
      display: 'block',
    },
    offerCountRow: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: theme.spacing(1, 5),
    },
    offerCountText: {
      color: theme.palette.text.primary,
      fontWeight: 700,
    },
    hiddenOfferMeta: {
      visibility: 'hidden',
    },
  }), { name: RecruitingContent.name });
export default function RecruitingContent(props: any) {
    const classes = useStyles();

    const primarySchool = props?.primarySchool
    const player = props?.player;
    const links = prepareLinks(player);
    const playerOffers = props?.playerOffers;
    const committedToTeam = props?.committedToTeam;
    const selectedPosition = props?.selectedPosition;
    return (
      <>
      <NamedBox
        headerContent={<CloseButton className={classes.closeButton} onClick={props?.onClose} />}
        name={`Recruiting - ${player?.firstName || ''} ${player?.lastName || ''}`}
      >
        <ListItem
          icon={ClassIcon}
          title='High School Class:'
          className={classes.listItem}
        >
          <div><b>{(primarySchool && primarySchool.graduatingClass) || 0}</b></div>
        </ListItem>

        <ListItem
          icon={SchoolIcon}
          title='School:'
          className={classes.listItem}
        >
          <div className={classes.dividedContent}>
            <div className={classes.dividedContentSection}>
              <span><strong>{(primarySchool?.name || <NotAvailable />)}</strong></span>
            </div>

            {
              !!player?.gpa && 
                <div className={classes.dividedContentSection}>
                  <span>GPA: <strong>{player?.gpa || <NotAvailable />}</strong> </span>
                </div>
            }

            {
              !!player?.sat && 
                <div className={classes.dividedContentSection}>
                  <span>SAT: <strong>{player?.sat || <NotAvailable />}</strong> </span>
                </div>
            }

            {
              !!player?.act && 
                <div className={classes.dividedContentSection}>
                  <span>ACT: <strong>{player?.act || <NotAvailable />}</strong> </span>
                </div>
            }
          </div>
        </ListItem>

      {!!playerOffers && (
        <ListItem
          icon={OffersIcon}
          title='Offers:'
          className={classes.listItem}
        >
          <div className={classes.offersRow}>
            <Tooltip title={
                <div style={{ maxHeight: 220, overflowY: 'auto', paddingRight: 8 }}>
                  {player?.offers?.sort()?.map((offer: any, index: number) => (
                    <span key={`${offer}-${index}`}>{offer}<br/></span>
                  ))}
                </div>
              }>
              <Chip label={playerOffers?.playerOffers?.length || 0} color='secondary' className={classes.chip} />
            </Tooltip>
            
            {playerOffers?.playerOffers?.map((offer: any) => {
              return (
                <Tooltip key={offer.teamName} title={offer.teamName} placement='top'>
                  <img
                    key={offer.teamName}
                    src={offer.logo247 || offer?.logoESPN}
                    alt={`${offer.teamName} logo`}
                    className={classes.offerLogo}
                  />
                </Tooltip>
              )
            })}
          </div>
        </ListItem>)}

        {!!playerOffers && (
        <ListItem
          icon={OffersIcon}
          iconClassName={classes.hiddenOfferMeta}
          title={<span className={classes.hiddenOfferMeta}>Offers:</span>}
          className={classes.listItem}
        >
          <div className={classes.offerCountRow}>
            <Typography className={classes.offerCountText}>P4 Offers: {playerOffers?.p4OfferCount || 0}</Typography>
            <Typography className={classes.offerCountText}>G6 Offers: {playerOffers?.g6OfferCount || 0}</Typography>
            <Typography className={classes.offerCountText}>FCS Offers: {playerOffers?.fcsOfferCount || 0}</Typography>
          </div>
        </ListItem>)}

        {!!playerOffers?.offerQualityScore && (
        <ListItem
          icon={TFPillLogoColorIcon}
          title='Offer Quality Score:'
          className={classes.listItem}
        >
          <ProgressLine className={classes.progressLine} value={(playerOffers?.offerQualityScore || 0) * 10} />
        </ListItem>)}

        {committedToTeam ? (
          <ListItem icon={HandshakeIcon} title="Committed:" className={classes.listItem}>
            <Box display="flex" alignItems="center">
              <div className={classes.committedTeam}>
                <TeamLogo team={committedToTeam} className={classes.committedTeamLogo} />
                <b>{formatDateToLongMonth(`${player?.committedDate}`)}</b>
              </div>
            </Box>
          </ListItem>
        ): (
          <ListItem icon={HandshakeIcon} title="Committed:" className={classes.listItem}>
            <Box display="flex" alignItems="center">
              <TeamsIcon className={classes.headerIcon} />
              <b>Uncommitted</b>
            </Box>
          </ListItem>
          )
        }

        {!!player?._247Star && (
            <ListItem
              icon={StarIcon}
              title='Star Rating:'
              className={classes.listItem}
            >
              <div className={classes.starRatingRow}>
                <Stars value={player?._247Star ?? player?.compStar ?? 0} />
                <b> {`${player?.industryNationalRank ? `#${player?.industryNationalRank} Overall` : ''}`}</b>
              </div>
            </ListItem>
          )}
        
        {!!player?._247Comp && (
            <ListItem
              icon={RugbyIcon}
              title='Industry Rating:'
              className={classes.listItem}
            >
              <ProgressLine className={classes.progressLine} value={player?._247Comp} />
            </ListItem>
          )}
        
        {!!player?.industryStateRank && (
            <ListItem
              icon={StateIllinoisIcon}
              title='State Rank:'
              className={classes.listItem}
            >
              <div>
                {
                  player?.industryStateRank ? 
                    <b>#{player?.industryStateRank} in {primarySchool?.state}</b>
                  : <NotAvailable />
                }
              </div>
            </ListItem>
          )}

        {!!player?.industryPositionRank && (
            <ListItem
              icon={PositionRankIcon}
              title={'Pos Rank:'}
              className={classes.listItem}
            >
              <div>
                {
                  player?.industryPositionRank ? 
                    <b>{selectedPosition || ''}: #{player?.industryPositionRank} Nationally</b>
                  : <NotAvailable />
                }
              </div>
            </ListItem>
          )}

        {
          player?.prepRedzoneStateRank || player?.prepRedzoneStatePosRank ? (
            <ListItem
              icon={StarIcon}
              iconClassName={classes.listHiddenIcon}
              title={<img src='/svgs/prep-redzone-logo.svg' alt='Prep Redzone'/>}
              className={classes.listItem}
            >
              <div className={classes.rankingWrap}>
                <div className={classes.rankingContent}>
                  <div>State Rank: {player?.prepRedzoneStateRank || <NotAvailable />}</div>
                  <div>Position Rank: {player?.prepRedzoneStatePosRank || <NotAvailable />}</div>
                </div>
                
                {
                  (player?.prepRedzoneRiser == 1) ?
                    <div className={classes.rankingIcon}>
                      <img
                        src='/images/rankings-riser-logo.png'
                        alt='Rankings Riser'
                      />
                    </div>
                  : ''
                }
              </div>
            </ListItem>
          )
          : null
        }
        
        {(!!links?.length) && (
          <Links
            className={classes.recruitingLinks}
            linkClassName={classes.recruitingLink}
            links={links}
            addDivider={false}
          />
        )}
      </NamedBox>
      </>
    )
  }